import { NavLink, useLocation } from 'react-router-dom'

interface NavItem {
  path: string
  label: string
  icon: React.ReactNode
}

// Home icon SVG
function HomeIcon() {
  return (
    <svg className="w-7 h-7" viewBox="0 0 28 28" fill="currentColor">
      <path d="M14 3.5L3.5 12.25V24.5H10.5V17.5H17.5V24.5H24.5V12.25L14 3.5Z" />
    </svg>
  )
}

// Explore/Compass icon SVG
function ExploreIcon() {
  return (
    <svg className="w-7 h-7" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="14" cy="14" r="10" />
      <polygon points="17,11 11,13 11,17 17,15" fill="currentColor" />
    </svg>
  )
}

// Profile icon SVG
function ProfileIcon() {
  return (
    <svg className="w-7 h-7" viewBox="0 0 28 28" fill="currentColor">
      <circle cx="14" cy="9" r="4" />
      <path d="M6 24C6 19.0294 10.0294 15 15 15H13C17.9706 15 22 19.0294 22 24H6Z" />
    </svg>
  )
}

const navItems: NavItem[] = [
  {
    path: '/',
    label: 'Home',
    icon: <HomeIcon />,
  },
  {
    path: '/hunts',
    label: 'Explore',
    icon: <ExploreIcon />,
  },
  {
    path: '/profile',
    label: 'Profile',
    icon: <ProfileIcon />,
  },
]

export function BottomNav() {
  const location = useLocation()

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50">
      {/* Brown gradient background matching Figma */}
      <div className="bg-gradient-to-b from-brown-800 to-brown-900 border-t-[3px] border-primary-400 shadow-[0px_-4px_20px_0px_rgba(120,53,15,0.3)]">
        <div className="max-w-lg mx-auto px-4">
          <div className="flex items-center justify-around h-20 relative">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className="relative flex flex-col items-center justify-center min-w-[80px] h-[66px]"
                >
                  {/* Active state background pill */}
                  {isActive && (
                    <div className="absolute -inset-2 bg-gradient-to-b from-primary-600 to-primary-700 rounded-[14px] shadow-[0px_10px_15px_-3px_rgba(225,113,0,0.5)]" />
                  )}

                  {/* Icon */}
                  <div className={`relative z-10 ${isActive ? 'text-cream-50' : 'text-primary-300'}`}>
                    {item.icon}
                  </div>

                  {/* Label */}
                  <span className={`relative z-10 text-xs font-bold mt-1 ${
                    isActive ? 'text-cream-50' : 'text-primary-300'
                  }`}>
                    {item.label}
                  </span>
                </NavLink>
              )
            })}
          </div>
        </div>
        {/* Safe area padding for iOS */}
        <div className="safe-area-bottom bg-brown-900" />
      </div>
    </nav>
  )
}
